var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";
var spinnerVariants = cva("animate-spin text-muted-foreground", {
    variants: {
        size: {
            sm: "h-4 w-4",
            default: "h-6 w-6",
            lg: "h-8 w-8",
        },
    },
    defaultVariants: {
        size: "default",
    },
});
var LoadingSpinner = React.forwardRef(function (_a, ref) {
    var className = _a.className, size = _a.size, message = _a.message, props = __rest(_a, ["className", "size", "message"]);
    return (_jsxs("div", __assign({ ref: ref, className: cn("flex items-center gap-2", className) }, props, { children: [_jsx(Loader2, { className: cn(spinnerVariants({ size: size })) }), message && (_jsx("span", __assign({ className: "text-sm text-muted-foreground animate-pulse" }, { children: message })))] })));
});
LoadingSpinner.displayName = "LoadingSpinner";
export { LoadingSpinner, spinnerVariants };
